module.exports = {
          srcSet: "/_next/static/images/img-immobilier@2x-160-5b9d4809eb7d35138a266095eaf77381.webp"+" 160w"+","+"/_next/static/images/img-immobilier@2x-292-dd38d6347f06427f5a1fffb620ff9abb.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-immobilier@2x-160-5b9d4809eb7d35138a266095eaf77381.webp",width: 160,height: 137},{path: "/_next/static/images/img-immobilier@2x-292-dd38d6347f06427f5a1fffb620ff9abb.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-immobilier@2x-160-5b9d4809eb7d35138a266095eaf77381.webp",
          toString:function(){return "/_next/static/images/img-immobilier@2x-160-5b9d4809eb7d35138a266095eaf77381.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }